exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.error[data-v-1a491d32] {\n  border: 1px solid red !important;\n  border-radius: 5px !important;\n}\n", ""]);

// exports
